import {
} from "../actions/themeActions";

const initialState = {

};

const themeReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default themeReducer;